import popup from '../modules/Popup';
const { __ } = wp.i18n;

export default {
  storageKey: 'wishlist',
  ids: [],
  wishlistLink: '',
  limit: 300,
  getIds() {
    let ids = localStorage.getItem(this.storageKey);

    if(!ids) {
      return [];
    }

    try {
      return JSON.parse(ids);
    } catch (e) {
      this.clear();
      return [];
    }
  },
  getCount() {
    return this.ids.length;
  },
  isInWishlist(id) {
    return this.ids.includes(parseInt(id));
  },
  clear()
  {
    localStorage.removeItem(this.storageKey);
  },
  add(id) {
    if(this.isInWishlist(id)) {
      return true;
    }
    if( this.getCount() >= this.limit ) {
      this.error(__(`You can\'t add more than ${this.limit} products`, 'canopia'));
      return false;
    }
    this.ids.push(parseInt(id));
    this.save();
    return true;
  },
  remove(id)
  {
    const index = this.ids.indexOf(parseInt(id));
    if (index > -1) {
      this.ids.splice(index, 1);
      this.save();
    }
  },
  save()
  {
    try {
      //Check for duplicated values
      this.ids = this.ids.filter((elem, pos, arr) => {
        return arr.indexOf(elem) === pos;
      });
      localStorage.setItem(this.storageKey, JSON.stringify(this.ids));
      document.body.dispatchEvent( new CustomEvent('wishlist_updated', {
        bubbles: false,
        detail: {
          count: this.getCount(),
        },
      }));
    } catch (e) {
      this.error(__('Item not saved', 'canopia'));
    }
  },
  error(message)
  {
    popup.open({
      title: __('Oh no...', 'canopia'),
      type: 'warning',
      message: `<p>${message}</p>`,
      close: {
        text: __('Try again', 'canopia'),
      }
    });
  },
  onWishlistUpdate()
  {
    this.updateCounter();
    this.updateWishlistLinkHandler();
  },
  onProductsLoaded(event) {
    const products = event.detail.products;
    if(undefined === products) {
      this.updateButtons();
    } else {
      let buttons = [];
      products.forEach(product => {
        buttons.push(product.querySelector('.btn-wishlist'));
      });
      this.updateButtons(buttons);
    }
  },
  createCounter(count)
  {
    if(!this.wishlistLink || count < 1) {
      return;
    }

    let counter = document.createElement('span');
    counter.classList.add('counter', 'position-absolute');
    counter.textContent = count;
    this.wishlistLink.appendChild(counter);
  },
  updateCounter() {
    if(!this.wishlistLink) {
      return;
    }

    let counter = this.wishlistLink.querySelector('.counter');
    let count = this.getCount();
    if(count > 0) {
      if(counter) {
        counter.textContent = count;
      } else {
        this.createCounter(count);
      }
    } else {
      if(counter) {
        counter.remove();
      }
    }
  },
  updateWishlistLinkHandler()
  {
    if(this.wishlistLink && this.wishlistLink.length === 0 ) {
      return;
    }

    if(this.getCount() > 0) {
      this.wishlistLink.removeEventListener('click', this.preventDefault);
    } else {
      this.wishlistLink.addEventListener('click', this.preventDefault);
    }
  },
  preventDefault(event)
  {
    event.preventDefault();
  },
  updateButton(button, inWishlist)
  {
   if(!button) {
     return;
   }
   if(inWishlist) {
     if(!button.classList.contains('active')) {
       button.classList.add('active');
     }
   } else {
     button.classList.remove('active');
   }
  },
  updateButtons(buttons)
  {
    if( ! buttons ) {
      buttons = document.querySelectorAll('.btn-wishlist');
    }

    if( !buttons || buttons.length === 0 ) {
      return;
    }

    buttons.forEach(button => {
      let id = button.dataset.productId;
      if(!id) {
        return;
      }
      this.updateButton(button, this.isInWishlist(id));
    });
  },
  addHandlers() {
    document.body.addEventListener('click', event => {
      if(event.target.classList.contains('btn-wishlist')) {
        event.preventDefault();
        let id = event.target.dataset.productId;
        if( undefined === id) {
          return;
        }
        let inWishlist = this.isInWishlist(id);
        let success = true;

        if(inWishlist) {
          this.remove(id);
        } else {
          success = this.add(id);
        }

        if(success) {
          this.updateButton(event.target, !inWishlist);
        }
      }
    });
    document.body.addEventListener('wishlist_updated', this.onWishlistUpdate.bind(this));
    document.body.addEventListener('products_loaded', this.onProductsLoaded.bind(this));
  },
  init() {
    this.wishlistLink = document.querySelector('.wishlist-link');

    if(!this.wishlistLink) {
      return;
    }

    this.ids = this.getIds();
    this.updateCounter();
    this.updateWishlistLinkHandler();
    this.updateButtons();
    this.addHandlers();
  },
}
